(function () {
  if (window.__ssCartDrawer) return;
  window.__ssCartDrawer = true;

  const RECO_SECTION = 'ss-cart-recommendations';

  /* --- Recommandations --- */
  async function loadReco(root) {
    const productId = root.dataset.productId;
    if (!productId) return;

    /* Horizon re-rend le tiroir à chaque retrait d'article (morph) : le
       conteneur peut être conservé avec son marqueur « chargé » alors que
       son rail a été vidé. On ne saute donc le chargement que si le rail
       contient bien des cartes pour ce même produit. */
    const currentRail = root.querySelector('[data-ss-cd-reco-rail]');
    if (root.dataset.loaded === productId && currentRail && currentRail.children.length) {
      root.hidden = false;
      return;
    }
    if (root.dataset.loaded === productId + ':empty') return;
    if (root.dataset.loading === productId) return;
    root.dataset.loading = productId;
    root.hidden = true;

    const params = new URLSearchParams({
      section_id: RECO_SECTION,
      product_id: productId,
      limit: root.dataset.limit || '6',
      intent: root.dataset.intent || 'related'
    });

    try {
      let base = (window.SS && SS.routes && SS.routes.root) || '/';
      if (!base.endsWith('/')) base += '/';
      const res = await fetch(`${base}recommendations/products?${params}`);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const rail = doc.querySelector('[data-ss-cd-reco-rail]');
      const target = root.querySelector('[data-ss-cd-reco-rail]');

      if (!rail || !rail.children.length || !target) {
        root.dataset.loaded = productId + ':empty';
        return;
      }

      /* SS 30/09 — chargement immédiat des images : sur Safari iOS, une image
         « lazy » placée dans un rail à défilement horizontal, à l'intérieur
         d'un tiroir qui s'ouvre, peut ne jamais se charger (cadre vide). */
      rail.querySelectorAll('img[loading="lazy"]').forEach((img) => img.setAttribute('loading', 'eager'));

      target.innerHTML = rail.innerHTML;
      root.dataset.loaded = productId;
      root.hidden = false;

      /* Ces cartes arrivent après le scan initial : sans cet appel,
         l'IntersectionObserver ne les observe jamais, et tout élément
         portant .ss-anim reste à opacity 0 — donc invisible. */
      window.ssScanAnimations?.(target);
    } catch (err) {
      console.error('SS — recommandations panier :', err);
    } finally {
      delete root.dataset.loading;
    }
  }

  /* --- Barre de livraison offerte --- */
  function updateFreeShipping(total) {
    document.querySelectorAll('[data-ss-cd-freeship]').forEach((el) => {
      const threshold = parseInt(el.dataset.threshold, 10);
      if (!threshold || threshold <= 0) return;

      const reached = total >= threshold;
      const percent = Math.min(100, Math.round((total / threshold) * 100));

      const fill = el.querySelector('[data-ss-cd-freeship-fill]');
      if (fill) fill.style.width = `${percent}%`;

      const track = el.querySelector('[data-ss-cd-freeship-track]');
      if (track) track.setAttribute('aria-valuenow', percent);

      const text = el.querySelector('[data-ss-cd-freeship-text]');
      if (text) {
        text.textContent = reached
          ? el.dataset.textReached || ''
          : (el.dataset.textPending || '').replace('{amount}', SS.formatMoney(threshold - total));
      }

      el.classList.toggle('is-reached', reached);
      if (track) track.setAttribute('aria-label', text ? text.textContent : '');
    });
  }

  /* --- Total dans le bouton de commande --- */
  function updateCheckout(total) {
    const base = window.SS_CONFIG?.strings?.checkout || 'Passer commande';
    document.querySelectorAll('.cart-drawer__summary .cart__checkout-button .button-text')
      .forEach((el) => {
        el.textContent = total ? `${base} — ${total}` : base;
      });
  }

  /* --- Passe complète sur le tiroir --- */
  function refresh(cart) {
    document.querySelectorAll('[data-ss-cd-reco]').forEach(loadReco);

    if (cart) {
      const total = SS.formatMoney(cart.total_price);
      updateCheckout(total);
      updateFreeShipping(cart.total_price);

      document.querySelectorAll('[data-ss-cd-count]').forEach((el) => {
        el.textContent = `${cart.item_count} ${cart.item_count > 1 ? 'articles' : 'article'}`;
      });
    } else {
      const el = document.querySelector('.cart-drawer__summary [data-cart-subtotal]');
      updateCheckout(el?.textContent.trim());
    }
  }

  document.addEventListener('ss:cart:update', (e) => refresh(e.detail?.cart));

  /* Le morph d'Horizon recrée le DOM : on repasse après chaque mutation */
  const observer = new MutationObserver(SS.debounce(() => refresh(), 120));

  /* SS 30/09 — ouverture du panier après un ajout.
     Horizon n'ouvre le tiroir que si <cart-drawer-component> porte l'attribut
     « auto-open » (réglage « Ouvrir automatiquement le panier », décoché ici) :
     après un ajout, rien ne s'affichait, sur mobile comme sur ordinateur. */
  function enableAutoOpen() {
    document.querySelectorAll('cart-drawer-component').forEach((el) => {
      if (!el.hasAttribute('auto-open')) el.setAttribute('auto-open', '');
    });
  }

  function watch() {
    enableAutoOpen();
    const inner = document.querySelector('.cart-drawer__inner');
    if (!inner) return;
    observer.observe(inner, { childList: true, subtree: true });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  document.addEventListener('shopify:section:load', watch);
})();
